import Vue from 'vue'
import Router from 'vue-router'
import GodBossHome from '../views/Home.vue'
import Promotion from '../views/Promotion.vue'
import PGPromo from '../views/PGPromo.vue'
import EsPromo from '../views/EsPromo.vue'
Vue.use(Router)

// Vue Router 3：重复跳转同一路由会抛 NavigationDuplicated，统一吞掉避免控制台报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'option',
      redirect: () => {
          return '/home';
      },
    },
    {
      path: '/home',
      name: 'Home',
      component: GodBossHome
    },
    {
      path: '/promotion',
      name: 'Promotion',
      component: Promotion
    },  
    {
      path: '/pgpromo',
      name: 'PGPromo',
      component: PGPromo  ,
    },
    {
      path: '/espromo',
      name: 'EsPromo',
      component: EsPromo
    }
  ]
})
